// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2WbJS","colMin":"styles_colMin__158U-","colCheckbox":"styles_colCheckbox__3JBJV"};